import React from "react";

const EmptyStatus = (props) => {

  return (
    <div className="EmptyStatus">
      <p>{props.status}</p>
    </div>
  )

}

EmptyStatus.defaultProps = {
  status: "Status message"
}

export default EmptyStatus;